var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticStyle: {
      "min-height": "350px"
    }
  }, [_vm._m(0), _vm.loading ? _c('div', {
    staticClass: "my-5 d-flex justify-content-center"
  }, [_c('b-spinner', {
    staticStyle: {
      "height": "74px",
      "width": "74px"
    }
  })], 1) : [_c('PercentageAvailabilityChartYearly', {
    attrs: {
      "series": _vm.seriesYearly,
      "element": "percentage-fleet-availability-yearly"
    }
  })]], 2);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex justify-content-between mb-3"
  }, [_c('div', {}, [_c('h5', {
    staticClass: "text-primary"
  }, [_c('strong', [_vm._v("PECENTAGE FLEET AVAILABILITY")])])])]);

}]

export { render, staticRenderFns }